


































































import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useFormat, useRouter } from 'vivat';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import PrettyCheck from 'pretty-checkbox-vue/check';

import receivableOrder from '@/table/delivery/receivableOrder';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useAuth from '@/useAuth';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonChip from '@/components/CommonChip.vue';
import CommonDeliveryStatusSelect from '@/components/Delivery/CommonDeliveryStatusSelect.vue';
import CommonModalWithReasonSelector from '@/components/DeliveryNote/CommonModalWithReasonSelector.vue';

import getDeliveries from '@/gql/delivery/getDeliveries.gql';
import acceptDeliveriesIntoHub from '@/gql/delivery/acceptDeliveriesIntoHub.gql';

const ReceivableList = defineComponent({
  setup() {
    const { me } = useAuth();
    const { router } = useRouter();
    const { translateDistanceType, distanceTypeToChipClass } = useDeliveryAreaCode();

    const filter = reactive({
      status: '',
      text: '',
      orderDate: {
        from: undefined,
        to: undefined,
      },
    });
    function clickDateHandler(date: any) {
      if (filter.orderDate.from === useFormat.date(date).computerShortDate()) {
        filter.orderDate = {
          from: undefined,
          to: undefined,
        };
      } else {
        filter.orderDate = {
          from: useFormat.date(date).computerShortDate(),
          to: useFormat.date(date).computerShortDate(),
        };
      }
    }
    const ordersVariable = computed(() => {
      const vars: {[key: string]: any} = {
        filter: {
          column: 'DELIVERY_NOTE_ID',
          operator: 'IS_NOT_NULL',
          OR: undefined,
        },
        filterDestinationHubId: me.hubId,
      };
      if (filter.text) {
        vars.filter.OR = filter.text !== '' ? [
          { column: 'CONTACT_NAME', operator: 'LIKE', value: `%${filter.text}%` },
          { column: 'ORDER_NUMBER', operator: 'LIKE', value: `%${filter.text}%` },
          { column: 'CUSTOMER_NAME', operator: 'LIKE', value: `%${filter.text}%` },
        ] : undefined;
      }
      return vars;
    });
    const getOrdersResult = (data: any) => data.deliveries;

    // Use with select box
    const selectedItemId: Ref<number[]> = ref([]);
    function selectItem(id: number | string) {
      const hitIndex = selectedItemId.value.indexOf(parseInt(id as string, 10));
      if (selectedItemId.value.indexOf(parseInt(id as string, 10)) > -1) selectedItemId.value.splice(hitIndex, 1);
      else selectedItemId.value.push(parseInt(id as string, 10));
    }

    const totalItems = ref(0);
    function handlerFetchData(queryData: any) {
      totalItems.value = queryData.total;
    }
    function handleSelectAllItem($event: any[]) { selectedItemId.value.push(...$event); }
    const selectedAll = computed(() => selectedItemId.value.length === totalItems.value);

    const acceptDeliveriesIntoHubMutation = useMutation(acceptDeliveriesIntoHub, () => ({
      variables: {
        ids: selectedItemId.value,
      },
      refetchQueries: ['getDeliveries'],
    }));

    function clickRowHandler(row: any) {
      router.push({ name: 'DeliveryInformation', params: { id: row.item.id } });
    }
    acceptDeliveriesIntoHubMutation.onDone(() => {
      selectedItemId.value = [];
    });

    return {
      me,
      translateDistanceType,
      distanceTypeToChipClass,

      filter,
      clickDateHandler,
      receivableOrder,
      getDeliveries,
      ordersVariable,
      getOrdersResult,

      totalItems,
      // use to confirm accept
      selectItem,
      selectedAll,
      selectedItemId,
      handlerFetchData,
      handleSelectAllItem,

      acceptDeliveriesIntoHubMutation,

      clickRowHandler,
    };
  },
  components: {
    PrettyCheck,
    CommonModalWithPreset,
    CommonDeliveryStatusSelect,
    CommonChip,
    CommonModalWithReasonSelector,
  },
});

export default ReceivableList;
